export function salesTypeNameCore() {
    const endpoint = '/vistaorder/salesTypes';

    return {
        endpoint,
    };
  }

  export function salesTypeNameFilter() {
    const parameter = 'SalesTypeCode';
    const secondHandoverParameter = 'SalesTypeSecondHandoverCode';

    // Get rows
    const getRows = (data) => {
      const rows = [];

      data.forEach((row, i) => {
        // Text/numeric values
        rows[i] = {
          value: row.filterValue,
          label: row.filterText,
        };
      });

      return rows;
    };

    return {
      parameter,
      secondHandoverParameter,
      getRows: getRows
    };
  }
